import React, { useMemo, useEffect } from "react";
import { useHistoryContext } from "../../../hooks/useHistoryContext.jsx";
import pathnameNames from "../../../data/breadcrumbs.json";
import "./breadcrumbs.scss";
import { useNavigate, useLocation } from "react-router-dom";

const Breadcrumbs = () => {
  const { history, updateHistory, clearHistory, resetHistory } = useHistoryContext();
  const navigate = useNavigate();
  const location = useLocation();

  // 🧩 Actualiza historial al cambiar de ruta
  useEffect(() => {
    const path = location.pathname;

    if (path === "/" || path === "/login" || path === "/lgn" || path === "/clave") {
      clearHistory();
      return;
    }

    if (path === "/home") {
      resetHistory();
    } else {
      updateHistory(path);
    }
  }, [location.pathname, updateHistory, clearHistory, resetHistory]);

  // 🏷️ Función para traducir las rutas a nombres legibles
  const renderBreadcrumbName = (path) => {
    const segments = path.split("/").filter(Boolean);

    return segments
      .map((segment) => {
        if (/^\d+$/.test(segment)) return ""; // ignora IDs numéricos
        return pathnameNames[segment] || segment;
      })
      .filter(Boolean)
      .join(" / ");
  };

  // 📜 Construcción de las migas
  const breadcrumbs = useMemo(() => {
    const breadcrumbNames = history.map((path) => renderBreadcrumbName(path));

    return (
      <ul className="breadcrumb">
        {history.map((path, index) => {
          if (["", "/", "/login", "/lgn", "/clave"].includes(path)) return null;

          let segmentName = breadcrumbNames[index] || path;

          // Limpieza de casos especiales
          if (index === history.length - 1) {
            segmentName = segmentName
              .replace(/^Mis Actos Administrativos\s*\/\s*/, "")
              .replace(/^Variación de datos personales\s*\/\s*/, "")
              .replace(/^actos\s*\/\s*/, "");
          }

          return (
            <li key={index}>
              <span
                className={`${
                  history.length - 1 !== index ? "breadcrumb-link" : "ultimo"
                }`}
                onClick={() => navigate(path)}
              >
                {segmentName}
              </span>
              {index < history.length - 1 && <span> &gt; </span>}
            </li>
          );
        })}
      </ul>
    );
  }, [history, navigate]);

  return <nav>{breadcrumbs}</nav>;
};

export default React.memo(Breadcrumbs);
